import {createSlice} from "@reduxjs/toolkit";
import { getBookingList, createBooking } from './action';

const initialState = {
  state: {
    items: [],
    paging: {}
  },
  loading: true,
  error: ''
} as BaseState<BookingState>

const slice = createSlice({
  name: 'bookingSlice',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getBookingList.pending, (state) => ({
        ...state,
        loading: true
      })
    )
    builder.addCase(getBookingList.fulfilled, (state, action) => {
        const { items, paging } = action.payload
        return {
          state: {
            items,
            paging
          },
          loading: false,
          error: null
        }
      }
    )
    builder.addCase(getBookingList.rejected, (state) => ({
        ...state,
        loading: false,
        error: 'Failed to get bookings, please try again'
      })
    )
    builder.addCase(createBooking.pending, (state) => ({
        ...state,
        loading: true
      })
    )
    builder.addCase(createBooking.fulfilled, (state) => ({
        ...state,
        loading: false,
        error: null
        }
      )
    )
    builder.addCase(createBooking.rejected, (state) => ({
        ...state,
        loading: false,
        error: 'Failed to create bookings, please try again'
      })
    )
  }
})

export default slice
